import { Button, Card, DateFormat, Divider, Text } from "components/common"
import styles from "../../index.module.less"
import { IconText } from "components/custom"
import { t } from "i18next"
import { Flex, Space } from "antd"
import { useState } from "react"

const CollapsableInsightCard = ({ data, loading }) => {
  const [seeMore, setSeeMore] = useState(false)

  return (
    <Card
      className={styles.basicCard}
      bodyStyle={{ padding: "16px" }}
      styles={{ header: { minHeight: 0, padding: "0 16px", background: "#f0f0f0" } }}
      loading={loading}
      title={
        <IconText
          icon="FiCalendar"
          title={
            <Text>
              {t("Last ") +
                (data?.length > 1 ? data?.length + t(" Conversation Summaries") : t(" Conversation Summary"))}
            </Text>
          }
        />
      }
    >
      <Flex gap={8} vertical>
        {data?.slice(0, 1)?.map(detail => (
          <Space size={8} direction="vertical">
            <DateFormat icon={""} date={detail?.endDateTime} dateColor={"#000000"} color={"#000000"} />
            <Text type="secondaryLight">{detail?.summaryPoints}</Text>
          </Space>
        ))}
        {seeMore &&
          data?.slice(1)?.map(detail => (
            <Space size={8} direction="vertical">
              <Divider style={{ borderTop: "1px dashed #d9d9d9", margin: "0px 0" }} />
              <DateFormat icon={""} date={detail?.endDateTime} dateColor={"#000000"} color={"#000000"} />
              <Text type="secondaryLight">{detail?.summaryPoints}</Text>
            </Space>
          ))}
      </Flex>
      {data?.length > 1 && (
        <span>
          <Button
            type="link"
            size="small"
            className="pointer text-underline p-0"
            style={{ height: "auto", color: "#0091BA" }}
            onClick={() => setSeeMore(!seeMore)}
            text={seeMore ? t("See Less") : t("See More")}
          />
        </span>
      )}
    </Card>
  )
}

export default CollapsableInsightCard
